import { useEffect } from "react";

const HeadwayAppChangelog = () => {
  useEffect(() => {
    let observer = null;
    let badgeObserver = null;

    const updateBadgePosition = () => {
      const badgeElements = document.querySelectorAll("#HW_badge_cont");
      if (badgeElements.length > 1) {
        for (let i = 1; i < badgeElements.length; i++) {
          badgeElements[i].remove();
        }
      }
      
      const badgeElement = document.getElementById("HW_badge_cont");
      const badgeNotifyElement = document.getElementById("HW_badge");

      if (badgeElement && badgeNotifyElement) {

        const element = document.getElementById("HW_frame_cont");
         
          if (element) {
            element.style.borderRadius = "10px";
            element.style.boxShadow = "0 0 3px rgba(99, 114, 130, 0.32), 0 8px 16px rgba(27, 39, 51, 0.08)";
            element.style.fontFamily = "'Poppins', sans-serif";
            document.body.style.fontFamily = "'Poppins', sans-serif";
            element.style.setProperty('font-family', "'Poppins', sans-serif", 'important');
            
          }

          
          

   
          
        // Disconnect the observer before performing updates
        if (observer) observer.disconnect();
        if (badgeObserver) badgeObserver.disconnect();

        // Apply position styles
        requestAnimationFrame(() => {
          badgeNotifyElement.style.position = "absolute";
          badgeNotifyElement.style.top = "1px";
          badgeNotifyElement.style.left = "1px";
          badgeElement.style.position = "absolute";
          badgeElement.style.left = "1px";

          badgeNotifyElement.style.setProperty("top", "1px", "important");
          badgeNotifyElement.style.setProperty("left", "1px", "important");
          badgeNotifyElement.style.setProperty("width", "15px", "important");
          badgeNotifyElement.style.setProperty("height", "15px", "important");
          badgeElement.style.setProperty("visibility", "visible", "important");
          // const iframe = document.querySelector('#HW_frame_cont iframe');
          
          const unseen = badgeNotifyElement.getAttribute("data-count-unseen");
         
          if (unseen == null || unseen == '') {
            
            badgeNotifyElement.style.display = "none";
          } else {
            
            badgeNotifyElement.style.display = "block";
          }
          
          // Log for debugging
          console.log("Badge positioned and styled!");

          // Re-apply observers if necessary
          observeBadgeChanges();
          observeHWBadgeChanges(); // Re-initialize mutation observer for badge changes
        });
      } else {
        console.error("Badge elements not found");
      }
    };

    const observeBadgeChanges = () => {
      const badgeElement = document.getElementById("HW_badge_cont");
      if (badgeElement && !observer) {
        observer = new MutationObserver(() => {
          // Only reconnect and update if there are significant changes
          observer.disconnect(); // Disconnect before making changes
          updateBadgePosition();
        });

        observer.observe(badgeElement, {
          attributes: true,
          childList: true,
          subtree: true,
        });

        console.log("MutationObserver started watching HW_badge_cont");
      }
    };

    const observeHWBadgeChanges = () => {
      const badgeNotifyElement = document.getElementById("HW_badge");
      if (badgeNotifyElement && !badgeObserver) {
        badgeObserver = new MutationObserver(() => {
          console.log("HW_badge changed, reapplying styles...");
          updateBadgePosition();
        });

        badgeObserver.observe(badgeNotifyElement, {
          attributes: true,
          childList: true,
          subtree: true,
        });

        console.log("MutationObserver started watching HW_badge");
      }
    };

    window.HW_config = {
      selector: ".changelogs-link",
      account: "ypo4NJ",
      callbacks: {
        onWidgetReady: function () {
          console.log("Widget is ready!");
          updateBadgePosition();
          
        },
        onShowWidget: function () {
          console.log("Widget opened!");
          updateBadgePosition();
        },
        onShowDetails: function (changelog) {
          console.log("Changelog Details:", changelog);
          updateBadgePosition();
        },
        onReadMore: function (changelog) {
          console.log("Read More Changelog:", changelog);
          updateBadgePosition();
        },
        onHideWidget: function () {
          console.log("Widget hidden");
          updateBadgePosition();
        },
      },
    };

    const script = document.createElement("script");
    script.src = "https://cdn.headwayapp.co/widget.js";
    script.async = true;

    script.onload = () => {
      console.log("Headway widget loaded!");
      updateBadgePosition();
      observeBadgeChanges();
      observeHWBadgeChanges(); // Start observing HW_badge changes

      const badgeElement = document.getElementById("HW_badge_cont");
      if (badgeElement) {
        badgeElement.addEventListener("mouseenter", handleBadgeHover);
        badgeElement.addEventListener("mouseleave", handleBadgeHoverOut);
        console.log("Event listeners added to badge");
      } else {
        console.error("Badge element not found after script load");
      }
    };

    // Handle hover to change background color with opacity
    const handleBadgeHover = () => {
      const imageElement = document.querySelector(".changelog-img");

      if (imageElement) {
        imageElement.style.backgroundColor = "rgba(209, 213, 219, 0.5)"; // 50% transparent platinum color
        console.log("Hover effect applied!");
      }
    };

    // Remove background when hover is removed
    const handleBadgeHoverOut = () => {
      const imageElement = document.querySelector(".changelog-img");

      if (imageElement) {
        imageElement.style.backgroundColor = "transparent";
        console.log("Hover effect removed!");
      }
    };

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
      if (observer) {
        observer.disconnect();
        observer = null;
      }
      if (badgeObserver) {
        badgeObserver.disconnect();
        badgeObserver = null;
      }

      const badgeElement = document.getElementById("HW_badge_cont");
      if (badgeElement) {
        badgeElement.removeEventListener("mouseenter", handleBadgeHover);
        badgeElement.removeEventListener("mouseleave", handleBadgeHoverOut);
      }
    };
  }, []);

  return null; // No HTML is returned directly from here
};

export default HeadwayAppChangelog;
